import styled from 'styled-components'

export const Button = styled.button`
    background-color: ${props => props.theme.color.primary};
    color: ${props => props.theme.color.white};
    padding: 1.5rem 2rem;
    font-size: 1.5rem;
    border: none;
    border-radius: 0.4rem;
    outline: none;
    cursor: pointer;
    transition: all 0.2s;
    text-transform: uppercase;
    &:hover {
        background-color: #219ACD;
    }
`